<script setup>
import { router, Head, Link, useForm, usePage } from '@inertiajs/vue3';
import JetFormSection from '@/Jetstream/SimpleFormSection.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetAuditorHeader from '@/Jetstream/AuditorHeader.vue';
import AppTheming from '@/Jetstream/AppTheming.vue';
import MultiSelect from '@vueform/multiselect';

// includes we need to front end locale magic
import { useI18n } from 'vue-i18n';

// Get locale as set in cookie
const { locale, fallbackLocale} = useI18n({ useScope: 'global' });

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const navigationSlugs = JSON.stringify(router.page.props.ziggy.navigationSlugs);
const urlNamePrefix = organisation ? "gi." : "";

const props = defineProps({
    availableTeams: Array,
    teamsExist: Boolean,
    auditorSession: Array,
    isGi: Boolean,
    team: Object
});

const form = useForm({
    team_id: null
});

const submit = () => {

    if (!props.isGi) {
        form.team_id = props.team.id;
    }
    form.transform(data => ({
        ...data,
        remember: form.remember ? 'on' : '',
        urlNamePrefix: urlNamePrefix,
        subdomain: 'auditor',
    })).post(route(urlNamePrefix+'auditor.teamSelect', {'subdomain':'auditor', 'programme': programme}), {
        onFinish: () => form.reset('code'),
    });
};

</script>

<template>

    <AppTheming />

    <Head title="Select Team" />

    <JetAuditorHeader v-if="organisation != undefined" :programme="programme" :organisation="organisation" />
    <JetAuditorHeader v-else :programme="programme" />

    <div id="content-wrapper" class="bg-gray-200 auditor-content-wrapper">
        <div id="main-content" class="container w-full pt-5 pb-5 mx-auto">

            <div class="sm:pl-10 sm:pr-10">
                <div class="mt-0 text-gray-500">
                    <div class="mt-10 mb-10 form-item-container">

                        <h1 class="dashboard-title">{{ $t('auditor.team.title') }}, {{ auditorSession['auditor_name'] }}</h1>


                        <p v-if="isGi" class="font-bold">{{ $t('auditor.team.toolkits_audit') }}: {{ auditorSession['organisation'].name }}</p>
                        <p v-if="!isGi" class="font-bold">{{ $t('auditor.team.assigned_team') }}: {{ team.name }}</p>

                        <JetFormSection @submitted="form" @submit.prevent="submit">
                            <template #form>
                                <div v-if="isGi">
                                    <JetLabel for="selectTeam" :value="$t('auditor.team.select_team')" class="flex flex-col font-bold sm:flex-row" />
                                    <div class="flex flex-col pt-5 form-item md:flex-row md:justify-center">
                                        <MultiSelect
                                            id="selectTeam"
                                            v-model="form.team_id"
                                            :options="props.availableTeams"
                                            :searchable="true"
                                            placeholder="Select Team"
                                            class="w-full border-gray-300 rounded-md focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                            >
                                        </MultiSelect>

                                        <input type="hidden" id="selectedTeam" value="team" />
                                    </div>

                                    <div class="flex flex-col pt-2 form-item md:flex-row md:justify-left text-danger">
                                        <div v-if="$page.props.errors.team" class="text-danger">{{ $page.props.errors.team[0] }}</div>
                                    </div>
                                </div>
                                <div class="flex justify-end mt-5">
                                    <JetButton :class="{ 'whitespace-nowrap w-full mt-5 md:mt-0 sm:inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-base text-white tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25 transition opacity-25': form.processing } " :disabled="form.processing">
                                        {{ $t('auditor.team.view_toolkit_button') }}
                                    </JetButton>
                                </div>
                            </template>
                        </JetFormSection>

                    </div>
                </div>
            </div>

        </div>
    </div>

</template>
